import type { HttpLayer } from '../http.js';
import type {
  AccountSkill,
  CreateAccountSkillRequest,
  DeleteAccountSkillResponse,
  ListAccountSkillsResponse,
  UpdateAccountSkillRequest,
} from '../types/skills.js';

export class SkillsResource {
  constructor(private http: HttpLayer) {}

  private prefix = '/v1/skills';

  async list(): Promise<ListAccountSkillsResponse> {
    return this.http.get(this.prefix);
  }

  async get(skillId: string): Promise<AccountSkill> {
    return this.http.get(`${this.prefix}/${skillId}`);
  }

  async create(params: CreateAccountSkillRequest): Promise<AccountSkill> {
    return this.http.post(this.prefix, params);
  }

  async update(skillId: string, params: UpdateAccountSkillRequest): Promise<AccountSkill> {
    return this.http.patch(`${this.prefix}/${skillId}`, params);
  }

  async delete(skillId: string): Promise<DeleteAccountSkillResponse> {
    return this.http.delete(`${this.prefix}/${skillId}`);
  }
}
